import { isEmptyStr, isNull } from "./util";

export const getRegExp = function (validatorName) {
  const commonRegExp = {
    number: '/^[-]?\\d+(\\.\\d+)?$/',
    letter: '/^[A-Za-z]+$/',
    letterAndNumber: '/^[A-Za-z0-9]+$/',
    mobilePhone: '/^[1][3-9][0-9]{9}$/',
    letterStartNumberIncluded: '/^[A-Za-z]+[A-Za-z\\d]*$/',
    noChinese: '/^[^\u4e00-\u9fa5]+$/',
    chinese: '/^[\u4e00-\u9fa5]+$/',
    email: '/^([-_A-Za-z0-9.]+)@([_A-Za-z0-9]+\\.)+[A-Za-z0-9]{2,3}$/',
    url: '/^([hH][tT]{2}[pP]:\\/\\/|[hH][tT]{2}[pP][sS]:\\/\\/)(([A-Za-z0-9-~]+)\\.)+([A-Za-z0-9-~\\/])+$/',
    positiveInteger10: '/^([1-9]|(1[0-0]))$/',
    positiveInteger0_10: '/^([0-9]|(1[0-0]))$/',
    positiveInteger: '/^\\d*$/',
    bodyTemperature: '/^(3\d|4[0-5])(\.\d)?$/',
  }

  return commonRegExp[validatorName]
}

const validateFn = function (validatorName, rule, value, callback, defaultErrorMsg) {
  //空值不校验
  if (isNull(value) || (value.length <= 0)) {
    callback()
    return
  }
  const reg = eval(getRegExp(validatorName))
  if (!reg.test(value)) {
    let errTxt = rule.errorMsg || defaultErrorMsg
    callback(new Error(errTxt))
  } else {
    callback()
  }
}

const FormValidators = {

  /* 数字 */
  number(rule, value, callback) {
    validateFn('number', rule, value, callback, '[' + rule.label + ']包含非数字字符')
  },

  /* 字母 */
  letter(rule, value, callback) {
    validateFn('letter', rule, value, callback, '[' + rule.label + ']包含非字母字符')
  },

  /* 字母和数字 */
  letterAndNumber(rule, value, callback) {
    validateFn('letterAndNumber', rule, value, callback, '[' + rule.label + ']只能输入字母或数字')
  },

  /* 手机号码 */
  mobilePhone(rule, value, callback) {
    validateFn('mobilePhone', rule, value, callback, '[' + rule.label + ']手机号码格式有误')
  },

  /* 1-10的正整数 */
  positiveInteger10(rule, value, callback) {
    validateFn('positiveInteger10', rule, value, callback, '[' + rule.label + ']只能输入1-10正整数')
  },

  /* 0-10的正整数 */
  positiveInteger0_10(rule, value, callback) {
    validateFn('positiveInteger0_10', rule, value, callback, '[' + rule.label + ']只能输入0-10正整数')
  },
  /* 体温 */
  bodyTemperature(rule, value, callback) {
    if (isNull(value) || (value.length <= 0)) {
      callback()
      return
    }
    // validateFn('bodyTemperature', rule, value, callback, '[' + rule.label + ']只能输入35-45内正整数/包含一位小数')
    if (!(/^(3[5-9]|4[0-5])(\.\d)?$/ ).test(value)) {
      callback(new Error(rule.errorMsg || '[' + rule.label + ']只能输入35-45内正整数/包含一位小数'));
      return;
    }
    callback();
  },

  /* 正整数不包含小数 */
  positiveInteger(rule, value, callback) {
    validateFn('positiveInteger', rule, value, callback, '[' + rule.label + ']只能输入正整数不包含小数')
  },

  /* 禁止空白字符开头 */
  noBlankStart(rule, value, callback) {
    //暂未实现
  },

  /* 禁止空白字符结尾 */
  noBlankEnd(rule, value, callback) {
    //暂未实现
  },

  /* 字母开头，仅可包含数字 */
  letterStartNumberIncluded(rule, value, callback) {
    validateFn('letterStartNumberIncluded', rule, value, callback, '[' + rule.label + ']必须以字母开头，可包含数字')
  },

  /* 禁止中文输入 */
  noChinese(rule, value, callback) {
    validateFn('noChinese', rule, value, callback, '[' + rule.label + ']不可输入中文字符')
  },

  /* 必须中文输入 */
  chinese(rule, value, callback) {
    validateFn('chinese', rule, value, callback, '[' + rule.label + ']只能输入中文字符')
  },

  /* 电子邮箱 */
  email(rule, value, callback) {
    validateFn('email', rule, value, callback, '[' + rule.label + ']邮箱格式有误')
  },

  /* URL网址 */
  url(rule, value, callback) {
    validateFn('url', rule, value, callback, '[' + rule.label + ']URL格式有误')
  },

  /* 数字 */
  idCardWoman(rule, value, callback) {//空值不校验
    if (isNull(value) || (value.length <= 0)) {
      callback()
      return
    }
    value = value.toUpperCase();

    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
    if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(value))) {
      callback(new Error(rule.errorMsg || "身份证号码格式不正确"));
      return;
    }

    // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
    // 下面分别分析出生日期和校验位
    var len, re;
    len = value.length;
    if (len === 15) {
      re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
      const arrSplit = value.match(re);
      // 检查生日日期是否正确
      const dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
      const bGoodDay = (dtmBirth.getFullYear == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
      if (!bGoodDay) {
        callback(new Error(rule.errorMsg || "身份证号码中的出生日期不正确"));
        return;
      } else {
        // 将15位身份证转成18位
        // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        const arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
        let nTemp = 0;
        let i;
        value = value.substr(0, 6) + '19' + value.substr(6, value.length - 6);
        for (i = 0; i < 17; i++) {
          nTemp += value.substr(i, 1) * arrInt[i];
        }
        value += arrCh[nTemp % 11];
        let sexno, sex; // 添加性别信息的变量
        sexno = value.substring(16, 17);
        const tempid = sexno % 2;
        if (tempid === 0) {
          callback();
          return;
        } else {
          callback(new Error(rule.errorMsg || "请输入女性身份证"));
          return;
        }
      }
    }

    if (len === 18) {
      re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
      const arrSplit = value.match(re);

      // 检查生日日期是否正确
      const dtmBirth = new Date(arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
      const bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
      if (!bGoodDay) {
        callback(new Error(rule.errorMsg || "身份证号码中的出生日期不正确"));
        return;
      } else {
        // 检验18位身份证的校验码是否正确。
        // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        const arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
        let nTemp = 0;
        let i;
        for (i = 0; i < 17; i++) {
          nTemp += value.substr(i, 1) * arrInt[i];
        }
        const valnum = arrCh[nTemp % 11];
        if (valnum != value.substr(17, 1)) {
          callback(new Error(rule.errorMsg || "身份证号码校验位不正确"));
          return;
        }
        let sexno, sex; // 添加性别信息的变量
        sexno = value.substring(16, 17);
        const tempid = sexno % 2;
        if (tempid === 0) {
          callback();
          return;
        } else {
          callback(new Error(rule.errorMsg || "请输入女性身份证"));
          return;
        }

      }
    }

    callback(new Error(rule.errorMsg || "身份证号码格式不正确"));
  },
  
  idCardMan(rule, value, callback) {//空值不校验
    if (isNull(value) || (value.length <= 0)) {
      callback()
      return
    }
    value = value.toUpperCase();

    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
    if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(value))) {
      callback(new Error(rule.errorMsg || "身份证号码格式不正确"));
      return;
    }

    // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
    // 下面分别分析出生日期和校验位
    var len, re;
    len = value.length;
    if (len === 15) {
      re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
      const arrSplit = value.match(re);
      // 检查生日日期是否正确
      const dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
      const bGoodDay = (dtmBirth.getFullYear == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
      if (!bGoodDay) {
        callback(new Error(rule.errorMsg || "身份证号码中的出生日期不正确"));
        return;
      } else {
        // 将15位身份证转成18位
        // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        const arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
        let nTemp = 0;
        let i;
        value = value.substr(0, 6) + '19' + value.substr(6, value.length - 6);
        for (i = 0; i < 17; i++) {
          nTemp += value.substr(i, 1) * arrInt[i];
        }
        value += arrCh[nTemp % 11];
        let sexno, sex; // 添加性别信息的变量
        sexno = value.substring(16, 17);
        const tempid = sexno % 2;
        if (tempid !== 0) {
          callback();
          return;
        } else {
          callback(new Error(rule.errorMsg || "请输入男性身份证"));
          return;
        }
      }
    }

    if (len === 18) {
      re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
      const arrSplit = value.match(re);

      // 检查生日日期是否正确
      const dtmBirth = new Date(arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
      const bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
      if (!bGoodDay) {
        callback(new Error(rule.errorMsg || "身份证号码中的出生日期不正确"));
        return;
      } else {
        // 检验18位身份证的校验码是否正确。
        // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        const arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
        let nTemp = 0;
        let i;
        for (i = 0; i < 17; i++) {
          nTemp += value.substr(i, 1) * arrInt[i];
        }
        const valnum = arrCh[nTemp % 11];
        if (valnum != value.substr(17, 1)) {
          callback(new Error(rule.errorMsg || "身份证号码校验位不正确"));
          return;
        }
        let sexno, sex; // 添加性别信息的变量
        sexno = value.substring(16, 17);
        const tempid = sexno % 2;
        if (tempid !== 0) {
          callback();
          return;
        } else {
          callback(new Error(rule.errorMsg || "请输入男性身份证"));
          return;
        }

      }
    }

    callback(new Error(rule.errorMsg || "身份证号码格式不正确"));
  },
  /* 数字 */
  idCard(rule, value, callback) {//空值不校验
    if (isNull(value) || (value.length <= 0)) {
      callback()
      return
    }
    value = value.toUpperCase();

    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
    if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(value))) {
      callback(new Error(rule.errorMsg || "身份证号码格式不正确"));
      return;
    }

    // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
    // 下面分别分析出生日期和校验位
    var len, re;
    len = value.length;
    if (len === 15) {
      re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
      const arrSplit = value.match(re);
      // 检查生日日期是否正确
      const dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
      const bGoodDay = (dtmBirth.getFullYear == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
      if (!bGoodDay) {
        callback(new Error(rule.errorMsg || "身份证号码中的出生日期不正确"));
        return;
      } else {
        // 将15位身份证转成18位
        // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        const arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
        let nTemp = 0;
        let i;
        value = value.substr(0, 6) + '19' + value.substr(6, value.length - 6);
        for (i = 0; i < 17; i++) {
          nTemp += value.substr(i, 1) * arrInt[i];
        }
        value += arrCh[nTemp % 11];

        callback();
        return;
      }
    }

    if (len === 18) {
      re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
      const arrSplit = value.match(re);

      // 检查生日日期是否正确
      const dtmBirth = new Date(arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
      const bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
      if (!bGoodDay) {
        callback(new Error(rule.errorMsg || "身份证号码中的出生日期不正确"));
        return;
      } else {
        // 检验18位身份证的校验码是否正确。
        // 校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        const arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
        let nTemp = 0;
        let i;
        for (i = 0; i < 17; i++) {
          nTemp += value.substr(i, 1) * arrInt[i];
        }
        const valnum = arrCh[nTemp % 11];
        if (valnum != value.substr(17, 1)) {
          callback(new Error(rule.errorMsg || "身份证号码校验位不正确"));
          return;
        }
        callback();
        return;
      }
    }

    callback(new Error(rule.errorMsg || "身份证号码格式不正确"));
  },
  /*测试
  test(rule, value, callback, errorMsg) {
    //空值不校验
    if (isNull(value) || (value.length <= 0)) {
      callback()
      return
    }

    if (value < 100) {
      callback(new Error('[' + rule.label + ']不能小于100'))
    } else {
      callback()
    }
  },
  */

  regExp(rule, value, callback) {
    //空值不校验
    if (isNull(value) || (value.length <= 0)) {
      callback()
      return
    }

    const pattern = eval(rule.regExp)
    if (!pattern.test(value)) {
      let errTxt = rule.errorMsg || '[' + rule.label + ']invalid value'
      callback(new Error(errTxt))
    } else {
      callback()
    }
  },

}

export default FormValidators
